import { render, staticRenderFns } from "./LocationStatistic.vue?vue&type=template&id=008a51ce&"
import script from "./LocationStatistic.vue?vue&type=script&lang=js&"
export * from "./LocationStatistic.vue?vue&type=script&lang=js&"
import style0 from "./LocationStatistic.vue?vue&type=style&index=0&id=008a51ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports